import { render } from "./TheHeader.vue?vue&type=template&id=10e914e0&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=10e914e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e914e0"]])

export default __exports__